import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BQLink } from '../../../../atoms/bqlink';
import { ArrowRightIcon, FourStarIcon } from '../../../../atoms/material-icons';
import EmptyState from '../empty-state';
import { widgetLink } from "../../../../../helpers/utils";
import './markets-news-options.m.css';

const MarketsNewsOptions = ({ newsData = [], widget = false }) => {
  const requiredMarketsNews = newsData?.slice(0, 15);
  const widgetParam = widget ? '?view=apps' : '';
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  if (initialLoading) {
    return <div styleName="loading-container"></div>;
  }

  return requiredMarketsNews && requiredMarketsNews?.length > 0 ? (
    <div styleName="overall-market-news-container">
      <div styleName="markets-news-container">
        <div>
          {requiredMarketsNews?.slice(0, 1).map((news, index) => (
            <BQLink href={new URL(news?.link).pathname} key={index}>
              <div styleName="image-container">
                <img src={news?.thumb_image + '?downsize=400:225'} alt="thumb image" styleName="thumb-image" />
                <h2 styleName="image-overlay">{news?.title}
                  {news?.tags?.includes('Research Reports') && (
                    <span className="exclusive-icon">
                      <FourStarIcon color="#CE9445" size="14px" />
                    </span>
                  )}
                </h2>
              </div>
            </BQLink>
          ))}
          <div styleName="news-container">
            {requiredMarketsNews?.slice(1, 6).map((news, index) => (
              <p styleName="news-item" key={index}>
                <BQLink href={new URL(news?.link).pathname}>
                  {news?.title}
                  {news?.tags?.includes('Research Reports') && (
                    <span className="exclusive-icon">
                      <FourStarIcon color="#CE9445" size="14px" />
                    </span>
                  )}
                </BQLink>
              </p>
            ))}
          </div>
        </div>
        <div styleName="news-container">
          {requiredMarketsNews?.slice(6, 14).map((news, index) => (
            <p styleName="news-item-alt" key={index}>
              <BQLink href={new URL(news?.link).pathname}>
                {news?.title}
                {news?.tags?.includes('Research Reports') && (
                  <span className="exclusive-icon">
                    <FourStarIcon color="#CE9445" size="14px" />
                  </span>
                )}
              </BQLink>
            </p>
          ))}
        </div>
      </div>
      <BQLink
        styleName="market-news-btn"
        href={widgetLink(`/all-market-news${widgetParam}`, widget)}
      >
        View All Market News
        <ArrowRightIcon styleName="tab-icon" color={isDarkMode && widget ? '#FFFFFF' : '#2b2b2b'} />
      </BQLink>
    </div>
  ) : (
    <div styleName="no-data-container-ext">
      <div styleName="no-data-container-int">
        <EmptyState />
      </div>
    </div>
  );
};

MarketsNewsOptions.propTypes = {
  newsData: PropTypes.array,
  loadingStatus: PropTypes.bool,
};

export default MarketsNewsOptions;
